import { BookOpen, Heart, FileCode, ListChecks, Info, Compass, Target, Eye, MessageSquare, LucideIcon } from "lucide-react";

export type MemoryCategory = 'facts' | 'preferences' | 'conventions' | 'instructions' | 'context' | 'values' | 'mission' | 'vision' | 'brand_voice';

export interface CategoryConfig {
  label: string;
  icon: LucideIcon;
  color: string;
  description: string;
}

export const MEMORY_CATEGORIES: Record<MemoryCategory, CategoryConfig> = {
  facts: {
    label: "Facts",
    icon: BookOpen,
    color: "hsl(217, 91%, 60%)", // Blue
    description: "Objective information, data points, and verifiable statements"
  },
  preferences: {
    label: "Preferences",
    icon: Heart,
    color: "hsl(346, 87%, 60%)", // Pink/Red
    description: "User preferences, likes, dislikes, and personal choices"
  },
  conventions: {
    label: "Conventions",
    icon: FileCode,
    color: "hsl(271, 81%, 60%)", // Purple
    description: "Coding standards, naming conventions, and stylistic rules"
  },
  instructions: {
    label: "Instructions",
    icon: ListChecks,
    color: "hsl(142, 76%, 45%)", // Green
    description: "Step-by-step procedures, guidelines, and directives"
  },
  context: {
    label: "Context",
    icon: Info,
    color: "hsl(38, 92%, 50%)", // Amber
    description: "Background information, situational details, and general context"
  },
  values: {
    label: "Values",
    icon: Compass,
    color: "hsl(280, 76%, 60%)", // Magenta
    description: "Core values, guiding principles, and fundamental beliefs"
  },
  mission: {
    label: "Mission",
    icon: Target,
    color: "hsl(200, 91%, 60%)", // Cyan
    description: "Mission statements, organizational purpose, and primary objectives"
  },
  vision: {
    label: "Vision",
    icon: Eye,
    color: "hsl(160, 76%, 50%)", // Teal
    description: "Vision statements, future aspirations, and long-term goals"
  },
  brand_voice: {
    label: "Brand Voice",
    icon: MessageSquare,
    color: "hsl(25, 85%, 55%)", // Orange
    description: "Brand voice, tone, communication style, and messaging guidelines"
  }
};

export const getCategoryConfig = (category: MemoryCategory): CategoryConfig => {
  return MEMORY_CATEGORIES[category];
};
